export const outOfPageTypeValues = [
  'bottomAnchor',
  'interstitial',
  'rewarded',
  'standard',
  'topAnchor',
] as const

export type OutOfPageType = (typeof outOfPageTypeValues)[number]
